import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import {
  InvoiceOperationResult,
  InvoiceDataEntity,
} from "../../entities/InvoiceEntity";
import type { ApprovalAuditPayload } from "../../../../../shared/utils/reviewWorkflow";

/**
 * Update Zoho Invoice Use Case
 * Updates an existing invoice in Zoho Books
 */
export class UpdateZohoInvoiceUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(
    invoiceId: number,
    invoiceData: InvoiceDataEntity,
    approvalAudit?: ApprovalAuditPayload,
  ): Promise<InvoiceOperationResult> {
    // Validate inputs
    // if (!invoiceId || invoiceId <= 0) {
    //   throw new Error("Valid invoice ID is required");
    // }

    // if (!invoiceData) {
    //   throw new Error("Invoice data is required");
    // }

    // // Validate required invoice data
    // if (!invoiceData.customer_id || invoiceData.customer_id.trim() === "") {
    //   throw new Error("Customer ID is required");
    // }

    // if (!invoiceData.invoice_number || invoiceData.invoice_number.trim() === "") {
    //   throw new Error("Invoice number is required");
    // }

    return await this.repository.updateZohoInvoice(
      invoiceId,
      invoiceData,
      approvalAudit,
    );
  }
}
